import { FC, ReactNode, useState } from 'react'
import ArrowUpSvg from '@/shared/assets/images/ArrowUp.svg'

interface ChildrenViewProps {
    title: ReactNode
    children?: ReactNode
    isOpen?: boolean
}

const ChildrenView: FC<ChildrenViewProps> = ({ children, title, isOpen=true}) => {
    const [isActive, setIsActive] = useState<boolean>(isOpen)
    return (
        <div className='flexbox'>
            <button
                onClick={() => setIsActive(prev => !prev)}
                className={`font-mediumttf flex items-center uppercase transition-all px-5 py-6 rounded-2xl border border-white bg-white text-color-base ${isActive ? 'text-color-primary !border-color-primary' : ''}`}
            >
                <div className='text-2xl'>
                    {title}
                </div>
                <div className='ml-auto mr-3'>
                    <ArrowUpSvg width={20} height={20} className={`transition duration-75  ${isActive ? 'rotate-0 text-color-primary' : 'rotate-180'}`} />
                </div>
            </button>
            {isActive
                ? <div className='w-full'>
                    {children}
                </div>
                : null
            }
            
        </div>
    )
}

type SubtitleVariant = "acid"

interface ViewProps {
    title: ReactNode
    variant?: SubtitleVariant
}

const View: FC<ViewProps> = ({ title, variant }) => {
    return (
        <div className={`font-mediumttf uppercase text-2xl py-6 px-5 rounded-2xl w-full ${variant === "acid" ? 'bg-color-dark text-color-acid' : 'text-white bg-color-secondary'}`}>
            {title}
        </div>
    )
}

interface PageSubtitleProps {
    title: ReactNode
    children?: ReactNode
    variant?: SubtitleVariant
    isOpen?: boolean
}

export const PageSubtitle: FC<PageSubtitleProps> = ({ title, variant, isOpen, children }) => {
    return (
        children
            ? <ChildrenView isOpen={isOpen} children={children} title={title} />
            : <View variant={variant} title={title}/>
    )
}